import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconUpload = (props) => (
  <Icon viewBox="0 0 30 31" fill="none" {...props}>
    <path
      d="M15.0201 25.5956V6.85245"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.03596 9.45354L14.9396 0.999994L23.964 9.45354"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 24.1804V28.235C29 28.6558 28.6374 29 28.1942 29H1.80576C1.36259 29 1 28.6558 1 28.235V24.1804"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
